import styled from 'styled-components'
import { colors } from '../theme'
import { SVG_URL } from "../constants"

const getBackground = (props) => {
  if (props.selected) {
    if (props.radio) {
       return `url("${SVG_URL}radio-fill.svg") no-repeat center`
    } else {
       return `${colors.white(props)}`
    }
  } else {
    return 'white'
  }
}

const CheckBox = styled.button`
  background: ${getBackground};
  border: solid 1px ${props => props.selected && !props.radio ? colors.primary(props) : colors.neutral(props)};
  border-radius: ${props => props.radio ? '50%' : 0};
  background-size: ${props => props.radio ? '0.45rem' : '0.6rem'};
  line-height: 0.8;
  padding: 0px;
  flex-shrink: none;
  display: flex;
  align-items: center;
  justify-content: center;
  justify-self: flex-end;
  flex-shrink: 0;
  appearance: none;
  cursor: pointer;
  width: ${props => props.width || '16px'};
  height: ${props => props.height || '16px'};

  html.non-touch &:hover {
    border-color: ${colors.primary};
  }
  
  &:after {
    content: "✕";
    color: ${props => props.selected ? colors.primary(props) : colors.white(props)};
    font-size: 12px;
  }

  &:disabled {
    border-color: ${colors.neutralLight};
    ${props => !props.radio && props.selected &&
        `background-color: ${colors.neutralLight(props)};`}
    cursor: not-allowed;
    ${props => props.radio && props.selected && 
      `background: url("${SVG_URL}radio-fill-gray.svg") no-repeat center;
      background-size: 0.45rem;`
    }
  }
`

export {CheckBox as default}


// WEBPACK FOOTER //
// ./assets/common/components/CheckBox.js